import React from "react";
import {connect} from "react-redux";
import {Text, TouchableOpacity, View, StyleSheet, ScrollView, Dimensions} from "react-native";
import Link from "../../Link/Link";
import AvatarIcon from "../../Header/AvatarIcon";
import SignetPicto from "../../Picto/SignetPicto";
import CommentairePicto from "../../Picto/CommentairePicto";
import ConfidentialPicto from "../../Picto/ConfidentialPicto";
import { LogBox } from 'react-native';

import PartagerMessagePicto from "../../Picto/PartagerMessagePicto";
import PostCategorie from "./PostCategorie";
import PostDate from "./PostDate";
import PostTags from "./PostTags";
import PostFile from "./PostFile";
import PostCitation from "./PostCitation";
import SignetActivePicto from "../../Picto/SignetActivePicto";
import PostComments from "./PostComments";
import PostCommentInput from "./PostCommentInput";
import ContactList from "../../Contact/ContactList";
import {addComment, getAllContact, getAllUser, getListComments, getPost, setBookmark} from "../../../API/API";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import SharePost from "./SharePost";
import {wrapAction, wrapStyle} from "../../../sw/helpers";
import MarkdownElement from "../../Shared/MarkdownElement";

LogBox.ignoreLogs(['Warning: ...']);
class PostFeed extends React.Component{
    constructor(props) {
        super(props);
        let bookmark = 0;
        if(this.props.bookmark!==undefined){
            bookmark = this.props.bookmark.indexOf(this.props.post.item.id)!==-1;
        }
        this.state = {
            isSave : bookmark,
            displayContactList : false,
            nbComment:0,
            commentInputValue:"",
            mentions:[],
            comments : this.props.post.item.comments,
            search : "",
            modalVisible : false,
            users  : [],
            target_users  : [],
            // refresh: "true", else: true
            focus_comment: ["true", true].includes(this.props.route?.params?.focus_comment)
        };

        // is the post in standalone mode?
        this.isPost = this.props.isPost || false;
        this._navigateToPost = this._navigateToPost.bind(this);
        this.setBookmark = this.setBookmark.bind(this);
        this.setDisplayContactList = this.setDisplayContactList.bind(this);
        this._navigateToEntityScreen = this._navigateToEntityScreen.bind(this);
        this.setCommentInputValue = this.setCommentInputValue.bind(this);
        this.addCommentMention = this.addCommentMention.bind(this);
        this.checkCommentMention = this.checkCommentMention.bind(this);
        this.submitCommentaire = this.submitCommentaire.bind(this);
        this.formatComment = this.formatComment.bind(this);
        this.navigateToProfil = this.navigateToProfil.bind(this);
        this.setInputRef = this.setInputRef.bind(this);
        this.setModalVisible = this.setModalVisible.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
    }

    componentDidMount() {
        this.getNbComment();
        this.getUsers();
        if (this.state.focus_comment) {
          this.inputRef.focus();
        }
    }

    setModalVisible(value){
        this.setState({
            modalVisible : value
        })
    }

    filterUser(user, post) {
      return user.is_active && (post.confidential ? user.has_confidential_access : true)
    }

    getUsers(){
	const post = this.props.post.item;

        getAllUser().then(data=>{
            this.setState({
                users: data.data,
                target_users: data.data.filter((user) => this.filterUser(user, post))
            });
        });
    }

    setSave(){
        this.setState({
           isSave : !this.state.isSave
        });
    }

    setCommentInputValue(param){
        if (typeof param=="string"){
            this.setCommentInputValueText(param);
        }else{
            this.setCommentInputEvent(param);
        }

        //this.checkCommentMention();
    }

    setCommentInputValueText(text){
        this.setState({
            commentInputValue: text,
            search:""
        });
        this.setDisplayContactList(false);
        this.inputRef.focus();
    }

    setCommentInputEvent(event){
        let text = event.nativeEvent.text ;
        let currentPosition =event.nativeEvent.target.selectionStart ;

        let search = this.state.search;
        let display;
        if(text.charAt(currentPosition-1)=="@"){
            this.setDisplayContactList(true);
        }else if(text.charAt(text.length-1)==" " || !text.includes("@")) {
            this.setDisplayContactList(false);
        }

        if(this.state.displayContactList){
            if(this.state.commentInputValue.length<text.length){
                search+=text.trim().charAt(text.trim().length-1);
            }else{
                search = search.slice(0, -1);
            }
        }else{
            search = "";
        }

        this.setState({
            commentInputValue: text,
            search:search
        });
    }

    setInputRef(ref){
        this.inputRef=ref;
    }

    addCommentMention(contact,search){

        let arobase = "";
        if(this.state.commentInputValue.charAt(this.state.commentInputValue.length -1)!='@'){
            arobase="@";
        }
        this.setState({
            mentions: [...this.state.mentions , {type:'mention',content:'@'+contact.firstname.replace(' ',''),user_id:contact.id}]
        });
        if(search.trim()!=""){
            this.setCommentInputValue(this.state.commentInputValue.replace('@'+search,arobase+contact.firstname.replace(' ','')+" ") );
        }else{
            this.setCommentInputValue(this.state.commentInputValue + arobase+contact.firstname.replace(' ','' )+ " ");
        }
    }

    indexOfAll(array, searchItem) {
        let i = array.indexOf(searchItem);
        let indexes = [];
        while (i !== -1) {
            indexes.push(i);
            i = array.indexOf(searchItem, ++i);
        }
        return indexes.sort().reverse();
    }

    checkCommentMention(){
        let mentions = this.state.mentions;
        this.setState({
            mentions : this.state.mentions.filter((item)=>this.state.commentInputValue.include(item.content))
        });
    }

    _navigateToPost(opts){
        const focus_comment = opts && opts.focus_comment;
        if(!this.isPost){
            this.props.refNavigation.navigate("PostFeed", { postId : this.props.post.item.id, focus_comment: focus_comment});
        }
    }

    _navigateToEntityScreen(item,type){
        this.props.refNavigation.navigate("EntityScreen", {type: type, id: item.id});
    }

    setDisplayContactList(value){
        this.setState({
            displayContactList: value
        })
    }

    setBookmark(){
        const id = this.props.post.item.id;
        const index = this.props.bookmark.indexOf(id);
        const isSave = index!==-1;

        let action  = "";

        if(!isSave){
            action="set";
            this.props.bookmark.push(id);
        }else{
            action="unset";
            this.props.bookmark.splice(index, 1);
        }

        this.setState({
            isSave : !isSave
        });

        setBookmark(id,action);
    }

    getNbComment(){
        // /!\ SW: comments could be null in the case of offline when built from feed item... (degraded experience)
        if(this.isPost && this.state.comments){
            this.setNbComment(this.formateNbComment(this.state.comments.length));
        }else{
            this.setNbComment(this.formateNbComment(this.props.post.item.comments_count))
        }
    }

    formateNbComment(nbComment){
        if(nbComment>0){
            return nbComment;
        }else if(nbComment>99){
            return "99+";
        }
        return "";
    }

    setNbComment(nbComment){
        this.setState({
            nbComment:nbComment
        });
    }

    submitCommentaire(){
        const formatComment = this.formatComment();

        if(formatComment.post_comment.body.length==0){
            return null;
        }
        let comments = this.state.comments;
        addComment(formatComment).then(data=>{
            getPost(this.props.post.item.id).then(data2=>{
                this.mentionConverseJs(formatComment.post_comment);
                this.setNbComment(this.formateNbComment(data2.comments.length));
                this.setState({
                   comments : data2.comments,
                    displayContactList:false,
                   commentInputValue:"",
                    mentions:[],
                });
            });
        })
    }

     mentionConverseJs(comment) {
        comment.body.forEach((item) => {
            if (item.type === 'mention') {
              window._converse.reticular.mention(item.user_id, comment.post_id);
            }
        });
    }

    sendMessage(ids){
            ids.forEach(user_id => {
                window._converse.reticular.sharePost(user_id, this.props.post.item.id);
            });
            this.setModalVisible(false);
    }

    navigateToProfil(id){
        this.props.refNavigation.navigate("MyProfil",{idProfil:id});
    }

    formatComment(){
        let commentText = this.state.commentInputValue.trim();
        let commentObj = {
            post_comment:{
                post_id:this.props.post.item.id,
                body:[]
            }};
        let commentTab = commentText.split(' ');
        let contentText = "";
        //debugger;
        commentTab.forEach((word,index)=>{
            if (word.startsWith('@')){
                if(index!=0){
                    commentObj.post_comment.body.push({type:"text",content:contentText});
                }

                contentText="";
                let mentions = this.state.mentions;
                let mention = mentions.filter(item=>item.content==word)[0];
                if(mention!=null){
                    commentObj.post_comment.body.push(mention);
                }else{
                    commentObj.post_comment.body.push({type:"text",content:word});
                }

           }else{

                let w = index==0? contentText += word : contentText += " "+word
            }
        });
        if(contentText!=""){
            commentObj.post_comment.body.push({type:"text",content:contentText});
        }

        return commentObj;
    }

    render() {
        // avoid at render...
        const { width,height } = Dimensions.get('window');

        const styles = StyleSheet.create({
           postContainer:{
                backgroundColor : this.props.theme.colors.primary.White.value,
               borderRadius:10,
               margin:(this.isPost)? 0:10,
               paddingHorizontal:20,
           } ,
            headContainer:{
                flexDirection:"row",
                justifyContent:"space-between",
                marginTop:18
            },
            postCategoryConfidentiality: {
              flexDirection:"row",
	    },
            postTagContainer:{
                marginTop:18,
                flexWrap:"wrap",
                flexDirection:"row",
                maxWidth:"100%"
            },
            dotContainer:{
                justifyContent:"center",
                alignItems:"center",
                marginTop:2,
                marginRight:5
            },
            dot:{
                backgroundColor:this.props.theme.colors.tertiary.black8.value,
                width:3 ,
                height:3,
                borderRadius:20
            },
            contentContainer:{

            },
            sourceContainer:{
                width:"100%",
                height:20,
                marginTop:15,
                marginBottom:15,

            },
            footerContainer:{
                flexDirection:"row",
                justifyContent:"space-between",

                marginBottom:20
            },
            postTag :{
                marginRight:5,
                color:this.props.theme.colors.primary.blue1.value,

            },
            geoTag:{
                color:this.props.theme.colors.secondary.pink1.value,
                fontWeight:"bold"

            },
            postTitle:{
                fontFamily:this.props.theme.fonts.title,
                fontWeight:"800",
                fontSize:17,
                marginTop:12,
                color:this.props.theme.colors.tertiary.black1.value
            },
            postText:{
                marginTop:5,
                fontFamily:this.props.theme.fonts.text,
                color:this.props.theme.colors.tertiary.black1.value
            },
            voirLaSuite:{
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"500",
                fontSize:14,
                color : this.props.theme.colors.tertiary.black6.value,
            },
            picto:{
               marginVertical:5,
                marginHorizontal:15
            },

            contributeurContainer :{
                flexDirection:"row",
                display:(this.isPost)? "flex": "none"
            },
            contributeurNameContainer:{
                marginLeft:10,
                marginBottom:25
            },
            textContributeur:{
                color:this.props.theme.colors.tertiary.black6.value,
                fontSize:13,
                fontWeight:"500"

            },
            nameContributeur:{
                color:this.props.theme.colors.tertiary.black1.value,
                fontSize:15,
                fontWeight:"500"
            },
            footerCommentShare:{
                flexDirection:"row"
            },
            commentaireContainer : wrapStyle({
                flexDirection:"row",
                alignItems:"center",
                marginRight:15
            }),
            nbCommentaire:{
                color : this.props.theme.colors.tertiary.black6.value,
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"500",
                fontSize:12,
                marginLeft:5
            },
            sharingContainer: wrapStyle({}),
            bookmarkContainer: wrapStyle({}),
            contactList : {
                position:"absolute",
                top:0,
                backgroundColor:this.props.theme.colors.primary.White.value,
                width:"100%",
                height:"100%"
            },
            separator:{
                width:width+20,
                marginLeft:-20,
                marginBottom:20,
               height:1,
                backgroundColor:this.props.theme.colors.tertiary.black13.value
            }
        });

        let post = this.props.post.item;
        return (
            <View style={{height :(this.props.isPost)?height-155:"100%"}}>
            <ScrollView style={{flex:1,marginBottom:(this.props.isPost)?70:0}}>
            <View style={styles.postContainer}>
                {!this.props.isExplorer && <View style={styles.headContainer}>
		    <View style={styles.postCategoryConfidentiality}>
		      <PostCategorie type={post.type}/>
		      { post.confidential && <ConfidentialPicto style={{width: 21, height: 21, marginLeft: 21}} isHeader={true}/> }
		    </View>
                    <PostDate post={post} />
                </View>}

                <PostTags _navigateToEntityScreen={this._navigateToEntityScreen} tagGeo={post.geo} tags={post.themes} />

                { !this.isPost &&
                  <TouchableOpacity onPress={this._navigateToPost}>
                      <View style={styles.contentContainer}>
                          <Text style={styles.postTitle}>{post.title}</Text>
			  { /* WARNING post.summary can't be properly rendered ... */ }
                          <Text numberOfLines={5} ellipsizeMode={"tail"} style={styles.postText}>{post.summary}</Text>
                          <Text style={styles.voirLaSuite}>{this.props.t('voir la suite')}</Text>
                      </View>
                  </TouchableOpacity>
                }

                { this.isPost &&
                  <View style={styles.contentContainer}>
                    <Text style={styles.postTitle}>{post.title}</Text>
                      <MarkdownElement text={post.description} />
                  </View>
                }

                {!this.props.isExplorer &&
                <View style={styles.sourceContainer}>
                    <Link label={post.source_name}
                          style={{parentText: {fontSize: 14, color: this.props.theme.colors.primary.blue1.value}}}
                          source={true} refNavigation={this.props.refNavigation} onPress={this._navigateToWebview}
                          url={post.source_url}/>
                </View>
                }

                <TouchableOpacity onPress={()=>{this.navigateToProfil(post.author.id)}} style={styles.contributeurContainer}>
                    <AvatarIcon style={{width:38,height:38,borderWidth:0,borderRadius:13}} icon={post.author.img}/>
                    <View style={styles.contributeurNameContainer}>
                        <Text style={styles.textContributeur}>{this.props.t('Contributeur')}</Text>
                        <Text style={styles.nameContributeur}>{post.author.firstname} {post.author.lastname.toUpperCase()}</Text>
                    </View>
                </TouchableOpacity>
                {
                    post.attachments.map((file)=>{
                        if(!this.props.isExplorer){
                            return <PostFile key={file.download_url} refNavigation={this.props.refNavigation}   file={{name:file.filename,url :file.download_url}} /> ;
                        }
                    })
                }
                <PostCitation isExplorer={this.props.isExplorer}  _navigateToEntityScreen={this._navigateToEntityScreen} citationsContact={post.contacts} citationsEntity={post.entities} />
                {!this.props.isExplorer &&
                <View style={styles.footerContainer}>
                    <View style={styles.footerCommentShare}>
                        <TouchableOpacity onPress={wrapAction(()=>{this._navigateToPost({ focus_comment: true })})} style={styles.commentaireContainer}>
                            <CommentairePicto style={{width: 21}} isHeader={true}/>
                            <Text style={styles.nbCommentaire}>{this.state.nbComment}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={wrapAction(()=>{this.setModalVisible(true)})} style={styles.sharingContainer}>
                            <PartagerMessagePicto style={{width: 22}} isHeader={true} />
                        </TouchableOpacity>
                    </View>
                    <TouchableOpacity onPress={wrapAction(this.setBookmark)} style={styles.bookmarkContainer}>
                        {(!this.state.isSave) ?  <SignetPicto isHeader={true} style={{width: 17}}/> : <SignetActivePicto  isHeader={true} style={{width: 17}}/> }
                    </TouchableOpacity>
                </View>}
                {this.isPost && <View>
		  <View style={styles.separator}></View>
		  <PostComments navigateToProfil={this.navigateToProfil} comment={this.state.comments} postId={post.id} />
		</View>}
        </View>

            </ScrollView>

                {this.isPost && <PostCommentInput setInputRef={this.setInputRef} submitCommentaire={this.submitCommentaire} postId={this.props.post.item.id} mentions={this.state.mentions} setCommentInputValue={this.setCommentInputValue}  commentInputValue={this.state.commentInputValue} setDisplayContactList={this.setDisplayContactList} /> }

                {this.isPost && this.state.displayContactList && <ContactList search={this.state.search} addCommentMention={this.addCommentMention} style={styles.contactList} contacts={this.state.target_users} /> }
                <SharePost  contacts={this.state.target_users} sendMessage={this.sendMessage} setModalVisible={this.setModalVisible} modalVisible={this.state.modalVisible}  />
            </View>
                );
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default compose(withTranslation(),connect(mapStateToProps)) (PostFeed);
